exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-d564f126] {\n  max-height: 204px;\n  overflow-y: auto;\n}\nul li[data-v-d564f126] {\n  padding: 0px;\n}\nul li a[data-v-d564f126] {\n  display: block;\n  padding: 8px 12px;\n  color: #333;\n}\nul li a[data-v-d564f126]:hover {\n  text-decoration: none;\n}\n", ""]);

// exports
